var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-item has-text-grey-dark has-back-button cursor-link",on:{"click":_vm.goPrevious}},[_c('span',{staticClass:"icon",class:_vm.iconSize},[_c('i',{staticClass:"mdi",class:[_vm.icon, _vm.size]})])])}
var staticRenderFns = []

export { render, staticRenderFns }